import { useMutation, MutationKey } from "react-query";
import Axios from "axios";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";

export function useRemoteDeleteFleet() {
  const { t } = useTranslation();
  const snackbar = useSnackbar();

  return useMutation<void, RemoteApiError, number>(
    ["fleet", "delete"] as MutationKey,
    async (id: number): Promise<void> => {
      try {
        await Axios.delete(`/fleet/vehicles/${id}`);
        snackbar.enqueueSnackbar(t("Successfully deleted vehicle"), { variant: "success" });
      } catch (error) {
        snackbar.enqueueSnackbar(t("There was a server error"), { variant: "error" });
        throw error;
      }
    }
  );
}
